export const MARKETPLACE_SELECTED = 'MARKETPLACE_SELECTED';

export function selectMarketplaceId(marketplaceId) {
  return {
    type: MARKETPLACE_SELECTED,
    marketplaceId,
  };
}
